// extracted by css-extract-rspack-plugin
module.exports =  {"closeButtonContainer":"ScopeChangeRequestActionSelectionDialog__closeButtonContainer___SjoSJ"};